import { 
    getBillChargeList,
    deleteBillCharge
    } from "@/apis/company/billChargeMode.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_bill_charge_list: 'bizBillChagerMode/set_bill_charge_list',
    set_edit_item: 'bizBillChagerMode/set_edit_item',
    set_filter_word: 'bizBillChagerMode/set_filter_word',

}

// count state 必須是 Object
const state = {
    billChargeList: [],
    editItem: {},
    filter: {
        word: null
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_BILL_CHARGE_LIST: (state) => {
        return state.billChargeList
    },
    GET_BIZ_BILL_CHARGE_EDIT_ITEM: (state) => {
        return state.editItem
    },
    GET_BIZ_BILL_CHARGE_MGT_FILTER_WORD: (state) => {
        return state.filter.word
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizBillChargeList ( {commit} ) {
        return new Promise((resolve, reject) => {
            getBillChargeList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    commit(types.set_bill_charge_list, res.data.result);
                }
                resolve()
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    delBizBillCharge ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            deleteBillCharge(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    dispatch('getBizBillChargeList')
                    dispatch('setAlarmStatus', {status: true,title: '成功刪除費用組合',type: 'success'})
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizBillChargeEditItem ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_edit_item, value);
            resolve()
        })
    },
    setBizBillChargeFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_bill_charge_list](state, data){
        state.billChargeList = data
    },
    [types.set_edit_item](state, data){
        state.editItem = data
    },
    [types.set_filter_word](state, data){
        state.filter.word = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/settingCenter/billChargeMode/billChargeMode.js